var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"head"},[_c('div',{staticClass:"title van-ellipsis"},[_vm._v(_vm._s(_vm.title))])]),[_vm._t("card")],[_vm._t("baseMessageCard")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }